export default __webpack_public_path__ + "bg-mobile.69a6b16.jpg";